import React, { useState } from 'react';
import { Modal, Banner } from '@/components/AdminPanel/AdminPrimitives';
import { LCBtn, CLS } from '@/components/common/LCPrimitives';

interface PasswordResetDialogProps {
  open: boolean;
  email: string;
  newPassword: string;
  onClose: () => void;
}

const PasswordResetDialog: React.FC<PasswordResetDialogProps> = ({ open, email, newPassword, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(newPassword);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleClose = () => { setCopied(false); onClose(); };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      title="Password Reset Successful"
      size="sm"
      footer={<LCBtn variant="primary" size="sm" onClick={handleClose}>Close</LCBtn>}
    >
      <Banner variant="success" className="mb-3">
        Password has been reset for <strong>{email}</strong>
      </Banner>
      <Banner variant="warn" className="mb-3">
        <strong>Important:</strong> Save this password securely. It will not be shown again!
      </Banner>

      <div className="flex gap-2 items-stretch mb-3">
        <input
          className={`${CLS.input} font-mono flex-1`}
          value={newPassword}
          readOnly
        />
        <button
          onClick={handleCopy}
          className="px-3 py-2 text-[11px] font-bold tracking-[0.08em] uppercase border border-black/[0.16] bg-white hover:bg-[#FAF9F8] transition-colors cursor-pointer shrink-0"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>

      <Banner variant="info" className="">
        Share this password with the user securely. They should change it after their first login.
      </Banner>
    </Modal>
  );
};

export default PasswordResetDialog;
